import { RootState } from '../../model/model'

export const viewportSelector = (state: RootState) => state.viewport
